import React from "react";
import { Link } from "react-router-dom";
import ColumnaBotoneraItem from "../ColumnaBotoneraItem.js";
import { NombreApellido } from "../../funciones/FuncionesPersona.js";
import styles from "../CuadroListaEditable.module.css";
import styleCols from "./TablaPersonaParientes.module.css";

const TablaPersonaParientes = (props) => {
  const lista = props.lista;
  const idElegido = props.idElegido;
  const onEditarItem = props.onEditarItem;
  const onEliminarItem = props.onEliminarItem;

  const esIdElegido = (idItem) => {
    return Number(idElegido) === Number(idItem);
  }

  return (
    <React.Fragment>
      <tr className={`${styles.titulos}`} key=".">
        <td className={`${styleCols.relacion}`}>Es</td>
        <td className={`${styleCols.pariente}`}>De</td>
        <td className={`${styles.editar}`}></td>
      </tr>
      {lista && lista.map((item, index) => (
        <tr className={`${styles.valores} ${(esIdElegido(item.id)) && styles.elegido}`} key={index}>
          <td className={`${styleCols.relacion}`}>
            {item.tipoParentesco && item.tipoParentesco.descripcion}
          </td>
          <td className={`${styleCols.pariente}`}>
            <Link to={"/persona/" + (item.pariente && item.pariente.id)} target="_blank" rel="noopener noreferrer">
              {NombreApellido(item.pariente)}
            </Link>
          </td>
          <ColumnaBotoneraItem idItem={item.id} onEditarItem={onEditarItem} onEliminarItem={onEliminarItem} />
        </tr>
      ))}
    </React.Fragment>
  );
};

export default TablaPersonaParientes;
